import BoxConsommationGraph from '@shared/components/box-consommation-graph';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FlotteExportWrapper from './flotte-export-wrapper';
import useData from './hook';
import { BilanCarboneGraphProps } from './type';

const BilanCarboneGraph: React.FC<BilanCarboneGraphProps> = ({ data }) => {
  const { consoData, unitToShow, unitIndexCO2, unitIndexData, unitLabelCO2, unitLabelData } = useData(data);
  const { t } = useTranslation('domain/home', {
    keyPrefix: 'consommationFlotte',
  });

  return (
    <BoxConsommationGraph
      consommationData={consoData}
      unitToShow={unitToShow}
      title={t('titre')}
      graphTitle={t('graphtitre')}
      info={t('info')}
      exportButton={
        <FlotteExportWrapper
          data={data}
          unitLabelCO2={unitLabelCO2}
          unitLabelData={unitLabelData}
          unitIndexCO2={unitIndexCO2}
          unitIndexData={unitIndexData}
        />
      }
    />
  );
};
export default BilanCarboneGraph;
